import * as TYPES from './types';
import {
    TRACK_UPDATE_SORT,
    TRACK_UPDATE_PAGE
} from '@/store/modules/track';
export default {
    [TYPES.IS_BIG_MAP_MUTATION](state, payload) {
        state.isBigMap = payload;
    },
    [TYPES.IS_GRID_OR_LIST_MUTATION](state, payload) {
        state.isGridOrList = payload;
    },
    [TYPES.PAGE_CHANGE_MUTATION](state, payload) {
        payload.page && (state.page = payload.page);
        payload.page && this.commit(`track/${TRACK_UPDATE_PAGE}`, payload.page);
        payload.pageSize && (state.pageSize = payload.pageSize);
    },
    [TYPES.SORT_UPDATE_MUTATION](state, payload) {
        state.sort = payload;
        this.commit(`track/${TRACK_UPDATE_SORT}`, payload);
    },
    [TYPES.MAP_DRAWING_CHANGE_MUTATION](state, payload) {
        state.drawing = payload;
    },
    [TYPES.UPDATE_LOADING_MUTATION](state, payload) {
        state.loading = payload;
    },
    [TYPES.UPDATE_IS_MAP_LOADING](state, payload) {
        state.isMapLoading = payload;
    },
    [TYPES.UPDATE_SEARCH_PARAMS](state, payload) {
        state.searchParams = { ...payload };
    },
    [TYPES.MAP_RESULT_UPDATE_MUTATION](state, payload) {
        if (
            state.layout === 'map' &&
            !state.mapType &&
            !state.isGridOrList &&
            !payload.noMapSearch
        ) {
            state.result.counts = payload.counts;
            state.result.searchType = payload.searchType;
        }
        state.mapResult = {
            house: payload.house,
            aggregation: payload.aggregation
        };
    },
    [TYPES.SORT_UPDATE_MUTATION](state, payload) {
        state.sort = payload;
    },
    [TYPES.GRID_OR_LIST_TYPE_MUTATION](state, payload) {
        state.gridOrListType = payload;
    },
    [TYPES.ACTIVE_HOUSE_MARKER_MUTATION](state, payload) {
        let selectedHouse = state.selectedHouse;
        let id = payload.id;
        selectedHouse[id] = payload.active;
        if (payload.active === 1) {
            let lid = state.lastSelectedHouse;
            if (lid && lid !== id && selectedHouse[lid] === 1) {
                selectedHouse[lid] = 0;
            }
            state.lastSelectedHouse = id;
        }
        state.selectedHouse = Object.assign({}, selectedHouse);
    },
    [TYPES.REMOVE_ALL_FILTERS](state) {
        state.keywords = [];
        state.conditions = {};
        state.conditionsArr = [];
        state.mapCondition = Object.assign({}, state.mapCondition, {
            mapPath: null,
            mapSearch: false
        });
    },
    [TYPES.SET_SORT_CONFIGS](state, payload) {
        state.listingSortOptions = payload;
    },
    [TYPES.SET_MAP_INITED](state, payload) {
        state.mapInited = payload;
    },
    [TYPES.REMOVE_OUTLINE_REGION](state) {
        state.mapCondition = Object.assign({}, state.mapCondition, {
            mapPath: null,
            mapSearch: false
        });
    },
    [TYPES.SET_MARKET_REPORT_DATA](state, payload) {
        state.marketReport = { ...payload };
    },
    [TYPES.PREV_VIEW_PATTERN_MUTATION](state, payload) {
        state.prevViewPattern = payload;
    },
    [TYPES.AVERAGE_DATA_MUTATION](state, payload) {
        state.averageData = payload;
    },
    [TYPES.SET_CENTER_POINT](state, payload) {
        state.centerPoint = payload;
    },
    [TYPES.SET_ZOOM](state, payload) {
        state.zoom = payload;
    },
    [TYPES.PROPERTY_GATHERING_AMOUNT](state, payload) {
        state.property_gathering_amount = payload;
    }
};
